<template>
  <div class="flex flex-row">
    <div class="flex flex-row space-x-2" v-if="material?.lessons.length > 0">
      <p class="ml-2 text-sm">
        {{
          $t("labels.generic", {
            pt: `Plano${material?.lessons.length > 1 ? "s" : ""}:`,
            en: `Plan${material?.lessons.length > 1 ? "s" : ""}:`,
          })
        }}
      </p>
      <p
        v-for="(lesson, i) in material?.lessons"
        :key="i"
        :class="`flex justify-center rounded-md items-center px-1 text-sm ${
          lesson === 'ESSENTIAL'
            ? 'bg-h-info-100 text-h-primary-500'
            : 'bg-h-secondary-50 text-h-secondary-600'
        }`"
      >
        {{
          $t("labels.generic", {
            pt: `${getMaterialTypePT(lesson)}`,
            en: `${lesson}`,
          })
        }}
      </p>
    </div>
    <div class="flex flex-row space-x-2" v-else>
      <p
        :class="`ml-2 flex justify-center px-1 rounded-md items-center text-sm bg-h-warning-100 text-h-warning-500`"
      >
        {{
          $t("labels.generic", {
            pt: `Sem plano`,
            en: `No plan`,
          })
        }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { MaterialsUtils } from "@/utils/materials.util";
import { defineComponent, PropType } from "vue";
export default defineComponent({
  name: "tagMaterials",
  props: {
    material: {
      type: Object as PropType<any>,
      default: {},
    },
  },
  computed: {
    materialsUtils(): MaterialsUtils {
      return new MaterialsUtils();
    },
  },
  methods: {
    getMaterialTypePT(lessonPlanName: string): string {
      return this.materialsUtils.getMaterialTypePT(lessonPlanName);
    },
    getIcon(icon: string): string {
      return this.materialsUtils.getIcon(icon);
    },
    getLearningGroupTypePT(learningGroup: string): string {
      return this.materialsUtils.getLearningGroupTypePT(learningGroup);
    },
  },
});
</script>
